// pages/Landing.js
import React from "react";

const Landing = () => {
  return <h1>Welcome!</h1>;
};

export default Landing;
